import { render, staticRenderFns } from "./FiveStars.vue?vue&type=template&id=f4c9ad8e&scoped=true&"
import script from "./FiveStars.vue?vue&type=script&lang=js&"
export * from "./FiveStars.vue?vue&type=script&lang=js&"
import style0 from "./FiveStars.vue?vue&type=style&index=0&id=f4c9ad8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c9ad8e",
  null
  
)

export default component.exports